export * from '@fhs/routing/src/routes/(drawer)/account/index';
export { default } from '@fhs/routing/src/routes/(drawer)/account/index';
